<template>
  <v-flex xs12>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-card class="px-3">
          <v-card-title primary-title class="title">New Procedure</v-card-title>
          <v-card-text class="pa-0">
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field disabled label="Patient" v-model="patient.name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :items="proceduresList"
                    v-model="newProcedure.procedures"
                    label="Select procedures "
                    item-value="id"
                    item-text="name"
                    return-object
                    multiple
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 v-for="(pro,i) in newProcedure.procedures" :key="i">
                  <strong>{{pro.name}}</strong>
                  <v-text-field
                    v-model="pro.fee"
                    suffix="AFN"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 class="text-xs-right mt-3">
                  <v-btn flat @click="clean">Close</v-btn>

                  <v-btn class="mx-0" :loading="loading" color="primary" @click="submit">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <!-- <v-flex xs12 sm3 md2>
        <v-card @click="dialog = true;" class="card-hover fill-height d-flex align-center">
          <v-icon color="primary" size="70">mdi-plus</v-icon>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md2 v-for="pros in patient.procedures" :key="pros.id">
        <v-card>
          <v-card-text class="text-xs-center">
            <div class="subheading font-weight-bold text-capitalize">{{pros.name}}</div>
            <div class="mt-2 caption grey--text text-capitalize">{{pros.date | moment('YYYY-MM-DD')}}</div>
          </v-card-text>
          <div
            class="text-xs-center white--text py-1 align-center d-flex"
            :class="{green: pros.status === 'done', orange: pros.status !== 'done'}"
          >
            <span class="text-capitalize">{{pros.status}}</span>
            <v-icon
              v-if="pros.status === 'confirmed'"
              color="white"
              @click.stop="deleteProcedure(pros)"
            >mdi-delete</v-icon>
          </div>
        </v-card>
      </v-flex>-->

      <v-flex xs12 px-1 mt-3>
        <div class="section-title di-flex justify-space-between">
          Procedures
          <v-btn small color="secondary" icon @click="dialog = true;" class="ma-0 shadow">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="patient.procedures"
          disable-initial-sort
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.date | moment('YYYY-MM-DD') }}</td>
              <td>{{ props.item.fee |  currency('AFN') }}</td>
              <td class="text-capitalize" :class="props.item.status">{{ props.item.status }}</td>
              <td>
                <v-tooltip top v-if="props.item.status === 'pending'">
                  <v-icon
                    slot="activator"
                    @click.stop="deleteProcedure(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      newProcedure: {
        procedures: []
      },
      headers: [
        { text: "Name", value: "name" },
        { text: "Date", value: "date" },
        { text: "Fee", value: "fee" },
        { text: "Status", value: "status" },
        { text: "", value: "status" }
      ]
    };
  },
  methods: {
    showProcedureDetails(procedure) {},
    deleteProcedure(procedure) {
      this.$modal.show({
        mode: "delete",
        message: `Are you sure you want to delete this Procedure? ${
          procedure.name
        }`,
        onConfirm: () => {
          this.axios
            .delete(
              `/api/patients/${this.patient.id}/procedures/${procedure.id}`
            )
            .then(() => this.$emit("refresh"))
            .finally(resp => {
              this.clean();
            });
        }
      });
    },
    submit() {
      if (this.newProcedure.procedures.length > 0) {
        this.loading = true;
        this.axios
          .post(
            `/api/patients/${this.patient.id}/procedures`,
            this.newProcedure
          )
          .then(resp => {
            this.$emit("refresh");
          })
          .finally(() => this.clean());
      }
    },
    clean() {
      this.$store.dispatch("base/loadProcedures");
      this.newProcedure.procedures = [];
      this.dialog = false;
      this.loading = false;
    }
  },
  computed: {
    proceduresList() {
      return this.$store.getters["base/procedures"];
    }
  },
  mounted() {
    this.$store.dispatch("base/loadProcedures");
  }
};
</script>